import { getMultiStepFormTemplate, getVueMultiStepFormTemplate } from "../../shortcodes/templates";

const SELECTOR = '[data-wrapper-id="multi-step-form-shortcode"]';

const visualizeMultiStepForm = content => {
  content.querySelectorAll(SELECTOR).forEach(item => {
    item.innerHTML = getMultiStepFormTemplate();
  });
};

const serializeMultiStepForm = content => {
  content.querySelectorAll(SELECTOR).forEach(item => {
    item.innerHTML = getVueMultiStepFormTemplate(item.getAttribute("data-multi-step-form-data"));
  });
};

export { visualizeMultiStepForm, serializeMultiStepForm };
